import { useCustomer } from '@melio/ar-domain';
import { useAnalyticsContext, withAnalyticsContext } from '@melio/platform-analytics';
import { forwardRef } from '@melio/platform-utils';

import { UpdateCustomerScreen } from './screens';

type UpdateCustomerActivityProps = {
  onClose: VoidFunction;
  onDone: VoidFunction;
  isOpen: boolean;
  onError?: ErrorFunction;
  customerId: string;
};

export const UpdateCustomerInnerActivity = forwardRef<UpdateCustomerActivityProps>(
  ({ onDone, onError, customerId, ...props }, ref) => {
    const { data: customer, isLoading, update, isMutating } = useCustomer({ id: customerId });

    useAnalyticsContext({ globalProperties: { CustomerId: customerId } });

    return (
      <UpdateCustomerScreen
        defaultValues={{ customerName: customer?.companyName || '', email: customer?.email || '' }}
        onSubmit={({ customerName, email }) => {
          update({ companyName: customerName, fullName: customerName, email }).then(onDone).catch(onError);
        }}
        isLoading={isLoading}
        isSaving={isMutating}
        ref={ref}
        {...props}
      />
    );
  }
);

export const UpdateCustomerActivity = withAnalyticsContext(UpdateCustomerInnerActivity);
